export default __webpack_public_path__ + "static/media/select.25cabf67.svg";